import { useEffect, useState } from "react";
import { useMergedTerms } from "~/features/chat/hooks/useMergedTerms";
import { useTermsStore } from "~/features/chat/stores/termsStore";
import type { Hint } from "~/features/chat/types";

export const useReportTerms = (caseId: string) => {
  const [aiTerms, setAiTerms] = useState<Array<Hint>>([]);
  const getTerms = useTermsStore((s) => s.getTerms);

  useEffect(() => {
    setAiTerms(getTerms(caseId));
    const unsubscribe = useTermsStore.subscribe((state) => {
      setAiTerms(state.getTerms(caseId));
    });
    return () => unsubscribe();
  }, [caseId, getTerms]);

  return useMergedTerms(aiTerms);
};
